import { makeStyles } from "@mui/styles";
import CRM from "@/assets/crm.svg";
import { useQuery } from "@/utils";
import { BigButton, BigClientOutlinedButton } from "@/components/button";
import useCRM from "@/hooks/useCRM";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

const useStyles = makeStyles({
  root: {
    textAlign: "center",
    color: "#4a4f54",
  },
  icon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    margin: "96px 0 82px",
    "@media (max-height: 768px)": {
      marginTop: -20,
    },
  },
  iconImg: {
    width: 189,
    height: 236,
  },
  title: {
    fontSize: "36px",
    fontWeight: 500,
    marginBottom: 16,
    textAlign: "center",
    color: "#2b3242",
  },
  contentWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  content: {
    width: 491,
    fontSize: "30px",
    color: "#6c727c",
    textAlign: "center",
  },
});

const CRMLogin = () => {
  const classes = useStyles();
  const { merchantId } = useParams();
  const { mode, id } = useQuery();
  const newWait = useSelector((state) => state.waitlist.edit.value);
  const { phone, name } = newWait;
  const {
    isHasOnBoardingRule,
    onBoardingRule,
    handleConfirmCRM,
    handleSkipCRM,
    isFirstLoad,
  } = useCRM(merchantId, "front");

  return (
    <div className={classes.root}>
      {isFirstLoad && (
        <>
          <div className={classes.icon}>
            <img className={classes.iconImg} src={CRM} />
          </div>
          <div className={classes.title}>
            {isHasOnBoardingRule
              ? `You’ll earn ${onBoardingRule.giftContent?.number} points`
              : "Join as Member for Free"}
          </div>
          <div className={classes.contentWrapper}>
            <div className={classes.content}>
              {isHasOnBoardingRule
                ? "Join as member for free and enjoy ongoing exclusive membership benefits"
                : "Join our membership and enjoy ongoing exclusive membership benefits."}
            </div>
          </div>
          <div>
            <BigButton
              mode={mode}
              onClick={() =>
                handleConfirmCRM({ phone, name }, () => handleSkipCRM(id, mode))
              }
            >
              <span>Join as Member for Free</span>
            </BigButton>
          </div>
          <div>
            <BigClientOutlinedButton onClick={() => handleSkipCRM(id, mode)}>
              <span>Skip</span>
            </BigClientOutlinedButton>
          </div>
        </>
      )}
    </div>
  );
};

export default CRMLogin;
